<div class="container">

  <app-header-dialog [iconName]="'playlist_add'">
    Vagas
  </app-header-dialog>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>playlist_add</mat-icon>
        <div>Vagas</div>
      </ng-template>

      <div class='content'>

        <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nomed</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O nome é obrigatório
            </mat-error>
          </mat-form-field>

          <div style='margin: 20px 0 20px 0'>
            <mat-form-field class="number-width" appearance="outline">
              <mat-label>Vagas</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.slot_quantity" autocomplete="off">
              <mat-error *ngIf="entityForm.controls.slot_quantity.hasError('required')">
                A quantidade é obrigatória.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="number-width" appearance="outline">
              <mat-label>Usada</mat-label>
              <input matInput readonly type="text" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.slot_used" autocomplete="off">
              <mat-error *ngIf="entityForm.controls.slot_used.hasError('required')">
                A quantidade usada é obrigatória.
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="number-width" appearance="outline">
              <mat-label>Espera</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.slot_wait"
                autocomplete="off">
              <mat-error *ngIf="entityForm.controls.slot_wait.hasError('required')">
                A quantidade espera é obrigatória.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="number-width" appearance="outline">
              <mat-label>Usada</mat-label>
              <input matInput readonly type="text" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.slot_wait_used" autocomplete="off">
              <mat-error *ngIf="entityForm.controls.slot_wait_used.hasError('required')">
                A espera usada espera é obrigatória.
              </mat-error>
            </mat-form-field>

          </div>

        </form>

        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
          <div [ngClass]="{hidden: !spinner}">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
          <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
          <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </div>

    </mat-tab>

    <mat-tab *ngIf='isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>format_list_bulleted</mat-icon>
        <div>Categorias</div>
      </ng-template>

      <div class='content'>

        <mat-form-field class="select-width" appearance="outline">
          <mat-label>Categorias</mat-label>
          <mat-select [errorStateMatcher]="matcher" [formControl]="catForm.controls.category_id">
            <mat-option *ngFor="let cat of categories" [value]="cat.id">
              {{ cat.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="catForm.controls.category_id.hasError('required')">
            Selecione uma categoria
          </mat-error>
        </mat-form-field>

        <button mat-raised-button (click)='addSlotCategory()' [disabled]="catForm.invalid">
          <mat-icon class='icon-add'>add_circle_outline</mat-icon>
        </button>

        <!-- TABLE -->
        <mat-table [dataSource]="categoryDataSource" style='width:100%; height:340px; overflow:auto; margin: 0;'>

          <!-- icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>format_list_bulleted</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Categoria </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }} </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='removeSlotCategory(element)' style='background-color: whitesmoke;'>
                <mat-icon class="icon-delete">
                  delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedCategoryColumns">
          </mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedCategoryColumns;">
          </mat-row>

        </mat-table>
        <!-- END TABLE -->

      </div>

    </mat-tab>

  </mat-tab-group>

</div>